import { transformAddress } from '@marketplace-web/address/address-data'

import {
  BusinessAccountInvoiceInstructionsDto,
  BusinessAccountInvoiceInstructionsModel,
} from '../types/transactions'

export const transformBusinessAccountInvoiceInstructionsDto = (
  business_account_invoice_instructions: BusinessAccountInvoiceInstructionsDto,
): BusinessAccountInvoiceInstructionsModel => {
  const {
    buyer: { address, email },
  } = business_account_invoice_instructions

  return {
    address: transformAddress(address),
    email,
  }
}
